/**
 * Helper function for client components to log metrics.
 * Usage: clientMetricLogger('pbs:feature:function', 'some message')
 * @param {string} namespace - should preceed related metric messages. e.g. pbs:passport:activation
 * @param {string} message - the metric message to log
 * @returns {Promise<void>}
*/
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();const clientMetricLogger = async (namespace: string, message: string,): Promise<void> => {
  const url = '/api/metric/';
  const body = { namespace, message };

  try {
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  } catch (error) {
    console.error('Failure sending metric', error)
  }
}

export { clientMetricLogger };
